import * as React from 'react';

import {ButtonCard} from 'shells/card/button-card';

import styles from './import-from-crm-list.module.css';

type Props = {
    label: string;
    onInitiateImport: () => void;
    imgSrc: string;
};

export function CrmCard(props: Props) {
    return (
        <ButtonCard onClick={props.onInitiateImport}>
            <div className={styles.content}>
                <img src={props.imgSrc} alt={props.label} className={styles.image} />
            </div>
        </ButtonCard>
    );
}
